var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { GoalPlannerNote } from '@/models/GoalPlannerNote';
import { formattedDate } from '@/support/Date';
import { Component, Prop, Vue } from 'vue-property-decorator';
let SingleNoteDialog = class SingleNoteDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.formattedDate = formattedDate;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    onClose() {
        this.$emit('close');
    }
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    get noteHtml() {
        return this.note?.note || '';
    }
    get noteDate() {
        return this.note?.created_at || this.note?.start_date || '';
    }
    get authorName() {
        return this.note?.author?.name || this.$tc('system');
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof GoalPlannerNote !== "undefined" && GoalPlannerNote) === "function" ? _a : Object)
], SingleNoteDialog.prototype, "note", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", String)
], SingleNoteDialog.prototype, "studentName", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", String)
], SingleNoteDialog.prototype, "subjectName", void 0);
SingleNoteDialog = __decorate([
    Component({})
], SingleNoteDialog);
export default SingleNoteDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
